const modules = import.meta.glob('./!(index|*.test).js', { eager: true });
const moduleExports = {};


for (const path in modules) {
  const moduleName = path.replace(/(\.\/|\.js)/g, "");
  moduleExports[moduleName] = modules[path].default;
}

export default moduleExports;
